/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_li_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate placeholder text for your designs, mockups and layouts — by paragraphs, sentences or words. Copy it with one click.`)
};

const es_li_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera texto de marcador para tus diseños, maquetas y diseños — por párrafos, oraciones o palabras. Cópialo con un solo clic.`)
};

const de_li_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generieren Sie Platzhaltertext für Ihre Designs, Mockups und Layouts — nach Absätzen, Sätzen oder Wörtern. Kopieren Sie ihn mit einem Klick.`)
};

const nl_li_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer plaatsaanduidingstekst voor je ontwerpen, mockups en lay-outs — per alinea, zin of woord. Kopieer het met één klik.`)
};

const fr_li_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générez du texte de remplissage pour vos conceptions, maquettes et mises en page — par paragraphes, phrases ou mots. Copiez-le en un seul clic.`)
};

const it_li_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera testo placeholder per i tuoi design, mockup e layout — per paragrafi, frasi o parole. Copia con un click.`)
};

const pt_br2_li_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere texto de espaço reservado para seus projetos, protótipos e layouts — por parágrafos, frases ou palavras. Copie com um clique.`)
};

const pt_li_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere texto espaço reservado para seus projetos, mockups e layouts — por parágrafos, frases ou palavras. Copie com um clique.`)
};

const ja_li_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デザイン、モックアップ、レイアウト用のプレースホルダーテキストを生成 — 段落、文、または単語単位で。ワンクリックでコピーできます。`)
};

const zh_li_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为你的设计、原型图和版面生成占位文本——按段落、句子或单词。一键复制。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const li_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.li_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("li_intro", locale)
	if (locale === "en") return en_li_intro(inputs)
	if (locale === "es") return es_li_intro(inputs)
	if (locale === "de") return de_li_intro(inputs)
	if (locale === "nl") return nl_li_intro(inputs)
	if (locale === "fr") return fr_li_intro(inputs)
	if (locale === "it") return it_li_intro(inputs)
	if (locale === "pt-BR") return pt_br2_li_intro(inputs)
	if (locale === "pt") return pt_li_intro(inputs)
	if (locale === "ja") return ja_li_intro(inputs)
	return zh_li_intro(inputs)
};